import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Beardvember. DOIT!",
  "description": "",
  "published": "2011-10-31T00:00:00.000Z",
  "redirect_from": ["/blog/beardvember-doit/swizec/2806"],
  "categories": "Beard, beardvember, Movember, noshember, Razor, Shaving, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/309262913_fe554e0a8c_m3.jpg",
        "alt": "YA Librarian Wins NV Beard Contest!",
        "title": "YA Librarian Wins NV Beard Contest!"
      }}></img></p>
    <p>{`A quick note for everyone who can grow a beard or at least a little bit of fluff on their face ... if you're a girl please oh please disregard this post even if you can grow something ... it's a note that Beardvember is starting and today is the last day you have to shave!`}</p>
    <p>{`Then you have a valid excuse not to shave for a whole month!`}</p>
    <p>{`Nagging girlfriends and wives be damned, Beardvember is a time for us dudes to celebrate how awesome we are!`}</p>
    <p>{`For anyone not familiar with the beardvember/noshember movement, here is a choice quote explaining it in detail:`}</p>
    <blockquote>
      <p parentName="blockquote">{`It is our mission to unify and beautify men through the common objective of obtaining a `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Beard",
          "title": "Beard"
        }}>{`full beard`}</a>{` throughout the month of November.`}</p>
      <p parentName="blockquote">{`For one month, we shall let our `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Facial_hair",
          "title": "Facial hair"
        }}>{`facial hair`}</a>{` grow as it was intended to. It is not a contest, but a celebration of the privilege we have received. A membership to this brotherhood of men is a commitment to excellence in the field of beard growing.`}</p>
      <p parentName="blockquote">{`On October 31st, we engage in the sacred Shaveabration ritual. For the month after that, no razors will touch our faces, only our magnificent hairs.`}</p>
      <p parentName="blockquote">{`Modern society tries to neuter us with a constant barrage of images of shaved, womanly men. For one month, real men shall band together in defiance of the unnatural social obligation of routine shaving. Some females, brainwashed by `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Misandry",
          "title": "Misandry"
        }}>{`anti-male`}</a>{` mass media, will tell you they do not like beards. These are not real women. There are only two types of women: women who love men with beards and lesbians. Never succumb to devious female tactics to make you shave. We are here to support you. Our strength lies in our solidarity.`}</p>
      <p parentName="blockquote">{`So what can you do to further the cause? Most importantly, wear your beard proudly. Tell all of your friends. Put up posters around your city or campus. Share this site or give it a Digg up. Join the Facebook group. Tell your dad. Tell your sons. Together, we shall overcome beardlessness.`}</p>
      <p parentName="blockquote">{`No Shave, No Vember.`}</p>
      <p parentName="blockquote">{`Ye shall not round the corners of your heads, neither shalt thou mar the corners of thy beard. - Leviticus 19:27`}</p>
    </blockquote>
    <p>{`Some of you might have heard of a fake movement called `}<a parentName="p" {...{
        "href": "http://www.movember.com/",
        "title": "Movember"
      }}>{`Movember`}</a>{`. Do not heed that movement! They are heathens and are trying to convince you to `}<em parentName="p">{`shave in november`}</em>{` and keep a moustache. A well kept, well groomed moustache!`}</p>
    <p>{`That is not what Beardvember is for! Celebrate your masculinity dude! (also you probably look ridiculous with a 'stache)`}</p>
    <p>{`And a note for all of us who can't grow a really good beard`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=_yVPewAybZw"
      }}>{`http://www.youtube.com/watch?v=`}{`_`}{`yVPewAybZw`}</a></p>
    <p>{`Remember, shaving is `}<em parentName="p">{`manual labor`}</em>{`.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gratefultothedead.wordpress.com/2011/10/22/why-does-god-love-beards/"
        }}>{`Why does God love beards?`}</a>{` (gratefultothedead.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.popsugar.com/PopSugar-Poll-Jake-Gyllenhall-Debuts-Big-Beard-Sorta-Sexy-Shave-Now-11262740"
        }}>{`Jake Gyllenhall Debuts an Even Bigger Beard - Sorta Sexy or Shave It Now?`}</a>{` (popsugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.3news.co.nz/Canada-rugbys-Adam-Kleeberger-fundraises-for-Chch/tabid/1534/articleID/229320/Default.aspx"
        }}>{`Canada rugby's Adam Kleeberger fundraises for Chch`}</a>{` (3news.co.nz)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.mirror.co.uk/news/top-stories/2011/10/11/man-wins-weird-beard-gong-for-pirates-of-the-caribbean-davy-jones-tribute-115875-23481731/"
        }}>{`Man wins weird beard gong for Pirates of the Caribbean Davy Jones tribute`}</a>{` (mirror.co.uk)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.mademan.com/mm/how-shave-your-pubic-area-men.html"
        }}>{`How To Shave Your Pubic Area For Men`}</a>{` (mademan.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=dc04883d-1d55-4d20-8a42-ee338ea03701",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      